export default __webpack_public_path__ + "static/media/no_image.d3a5082f.jpg";